export var TrackableStatus;
(function (TrackableStatus) {
    /** Not a trackable item, or doesn't include trackable items. */
    TrackableStatus[TrackableStatus["None"] = 0] = "None";
    /** Trackable item that is not synced with Trackable Remote Service yet. */
    TrackableStatus[TrackableStatus["Unconfirmed"] = 1] = "Unconfirmed";
    /** Is synced with Trackable Remote Service. */
    TrackableStatus[TrackableStatus["Confirmed"] = 2] = "Confirmed";
})(TrackableStatus || (TrackableStatus = {}));
